import React, { useState,useEffect } from 'react';
import '../Assets/Css/contact.css';
import { Container, Row, Col, Form, Button,Card } from 'react-bootstrap';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaGlobe } from 'react-icons/fa';

import axios from 'axios';
import { Spinner } from 'react-bootstrap';
import toast, { Toaster } from 'react-hot-toast';
import { BASE_URL } from '../BaseURL';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Helmet } from 'react-helmet';

export default function Contact() {
  useEffect(() => {
      AOS.init({ duration: 1000 });
    }, []);
 
    const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    email: '',
    address: '',
    message: ''
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        userName: formData.name,
        mobile: formData.mobile,
        email: formData.email,
        address:formData.address,
        message: formData.message
      };

      const response = await axios.post(`${BASE_URL}/enquiry/sendContactEnquiry`, payload);

      toast.success(response.data.message || 'Message sent successfully');
      setFormData({ name: '', mobile: '', email: '', message: '' });
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to send message');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mainnav min-vh-100">

     <Helmet>
        <title>Contact Us | XtraGrow Foundation, Inc.</title>
        <meta
          name="description"
          content="Contact XtraGrow Foundation to learn more about our programs, partnerships, and how you can support organic agriculture education in your community."
        />
        <meta
          name="keywords"
          content="contact XtraGrow, XtraGrow address, XtraGrow email, sustainable farming contact, organic education inquiry, XtraGrow Foundation contact"
        />
        <meta name="author" content="XtraGrow Foundation, Inc." />
        <link rel="canonical" href="https://xtragrowfoundation.org/contact" />

        {/* Open Graph Meta Tags */}
        <meta property="og:title" content="Contact Us | XtraGrow Foundation" />
        <meta
          property="og:description"
          content="Reach out to XtraGrow Foundation for information about our sustainable agriculture programs, partnerships, and volunteering opportunities."
        />
        <meta property="og:url" content="https://xtragrowfoundation.org/contact" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://xtragrowfoundation.org/images/contact-banner.jpg"
        />

        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Contact Us | XtraGrow Foundation" />
        <meta
          name="twitter:description"
          content="Connect with XtraGrow Foundation to explore how you can be part of our organic farming mission."
        />
        <meta
          name="twitter:image"
          content="https://xtragrowfoundation.org/images/contact-banner.jpg"
        />
      </Helmet>

      <Toaster/>

      {/* Hero Section */}
      <section className="hero-section3">
        <div className="overlay">
          <h1 data-aos="zoom-in">Contact Us</h1>
          <p className="text-white" data-aos="zoom-in">Home | Contact Us</p>
        </div>
      </section>

      {/* Contact Details */}
      <section id="contact-details" className="py-5 contact-section">
        <Container>
          <Row className="mb-4">
   <h2 className='page-title' data-aos="fade-up">Get  <span style={{ color: '#078825' }}>In Touch </span>  </h2>
</Row>

  <Row className="justify-content-center">
    <Col md={12}>
      <Row className="g-5 justify-content-center">
        {/* Address Card */}
        <Col md={4}>
          <Card className="h-100 shadow rounded bg-white">
            <Card.Body style={{ padding: '30px' }}>
              <Card.Title className="mb-3">
                <FaMapMarkerAlt className="me-2" style={{ color: '#036839' }} />
                Address
              </Card.Title>
              <Card.Text>
                Texas 75077,USA
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>

        {/* Email Card */}
        <Col md={4}>
          <Card className="h-100 shadow rounded bg-white">
            <Card.Body style={{ padding: '30px' }}>
              <Card.Title className="mb-3">
                <FaEnvelope className="me-2" style={{ color: '#036839' }} />
                Email
              </Card.Title>
              <Card.Text>
                <strong>Logistics:</strong> david@xtragrowfoundation.org <br />
                <strong>Programs:</strong> deborah@xtragrowfoundation.org
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Col>
  </Row>
        </Container>
     </section>


<section className="contact-form-section">
  <Container>
    <Row className="justify-content-center">
      <Col md={8}>
        <Row className="p-2 h-100 align-items-stretch justify-content-center">
          {/* Contact Form Card */}
          <Col md={12} className="d-flex h-100">
            <div className="p-4 shadow rounded bg-white w-100 contact-form-box">
              <h3 className="mb-3 text-center" style={{ color: '#036839' }}>Contact Form</h3>
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formName">
                      <Form.Label>Name</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter your name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="formMobile">
                      <Form.Label>Mobile Number</Form.Label>
                      <Form.Control
                        type="tel"
                        placeholder="Enter your mobile number"
                        name="mobile"
                        value={formData.mobile}
                        onChange={handleChange}
                        pattern="[0-9]{10}"
                        required
                        maxLength={10}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              
               <Row>
                   <Col md={6}>
                <Form.Group className="mb-3" controlId="formEmail">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter your email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                </Col>
                <Col md={6}>
                <Form.Group className="mb-3" controlId="formAddress">
                  <Form.Label>Address</Form.Label>
                  <Form.Control
                     as="textarea"
                    rows={1}
                    placeholder="Enter your address"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                </Col>
                 </Row>

                <Form.Group className="mb-3" controlId="formMessage">
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    placeholder="Your message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

               <div className="text-center mt-3">
  <Button style={{ border: 'none' }} className="btn-get" type="submit" disabled={loading}>
    {loading ? (
      <>
        <Spinner animation="border" size="sm" role="status" className="me-2" />
        Sending...
      </>
    ) : (
      'Send Message'
    )}
  </Button>
</div>

              </Form>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  </Container>
</section>
      
      <section className="map-section mt-5">
  <Container  className="p-0">
     
      <h2 className='page-title' data-aos="fade-up">Find Us <span style={{ color: '#078825' }}>on the Map </span>  </h2>

      <iframe 
      title="XtraGrow Foundation"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3342.548725532475!2d-97.0680335243241!3d33.09465507353255!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864c32e5d0516be7%3A0x6333282b75d69262!2s810%20Green%20Valley%20Ln%2C%20Highland%20Village%2C%20TX%2075077%2C%20USA!5e0!3m2!1sen!2sin!4v1749621912292!5m2!1sen!2sin" 
      width="100%" 
      height="450" 
      allowfullscreen=""
       loading="lazy" 
       referrerpolicy="no-referrer-when-downgrade">

       </iframe>
  
  </Container>
</section>
      
    </div>
  );
}
